import Vue from 'vue'
import VueRouter from 'vue-router'
import ls from '@utils/localStore'
import { getRoleKey, getRolesForModule, isCentralAccount } from '@utils/user-role'

const _import = file => () => import('@/views/' + file + '.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: _import('home/index')
  },
  {
    path: '/login',
    name: 'login',
    component: _import('login/index'),
    meta: { noAuth: true }
  },
  {
    path: '/ai-chat',
    name: 'ai-chat',
    component: _import('ai-chat/index')
  },
  {
    path: '/szmgzhc',
    name: 'szmgzhc',
    component: _import('szmgzhc/index')
  },
  {
    path: '/workspace',
    name: 'workspace',
    component: _import('workspace/layout'),
    children: [
      {
        path: 'list',
        name: 'demonstrate-list',
        meta: { roleModule: 'zzjs' },
        component: _import('workspace/demonstrate-list/index')
      },
      {
        path: 'demonstrate',
        name: 'demonstrate',
        meta: { roleModule: 'zzjs' },
        component: _import('workspace/demonstrate/index')
      },
      {
        path: 'rolemodel',
        name: 'rolemodel',
        meta: { roleModule: 'zzjs' },
        component: _import('workspace/rolemodel/index')
      },
      {
        path: 'lookback',
        name: 'lookback',
        meta: { roleModule: 'zzjs' },
        component: _import('workspace/lookback/index')
      },
      {
        path: 'lookback/operation',
        name: 'lookback-operation',
        meta: { roleModule: 'zzjs' },
        component: _import('workspace/lookback/operation')
      },
      {
        path: 'party-info',
        name: 'party-info',
        meta: { roleModule: 'sxzzjs' },
        component: _import('workspace/party/index')
      },
      {
        path: 'party-edit',
        name: 'party-edit',
        meta: { roleModule: 'sxzzjs' },
        component: _import('workspace/party/edit')
      },
      {
        path: 'party-list',
        name: 'party-list',
        meta: { roleModule: 'sxzzjs' },
        component: _import('workspace/party-list/index')
      },
      {
        path: 'education',
        name: 'education',
        meta: { roleModule: 'sxzzjs' },
        component: _import('workspace/education/index')
      },
      {
        path: 'education-base-info/:uid?/:status?', // 民革支部-教育基地-详情
        name: 'education-base-info',
        meta: { roleModule: 'sxzzjs' },
        component: _import('workspace/education/info')
      },
      {
        path: 'education-base-cockpit-list', // 民革支部-教育基地-驾驶舱-列表
        name: 'education-base-cockpit-list',
        meta: { roleModule: 'sxzzjs' },
        component: _import('workspace/education/cockpit-list')
      },
      {
        path: 'role-model-cockpit-list', // 民革支部-榜样人物-驾驶舱-列表
        name: 'role-model-cockpit-list',
        meta: { roleModule: 'zzjs' },
        component: _import('workspace/rolemodel/cockpit-list')
      },
      {
        path: 'role-model-info/:status?/:uid?', // 民革支部-榜样人物-详情
        name: 'role-model-info',
        meta: { roleModule: 'zzjs' },
        component: _import('workspace/rolemodel/info')
      },
      {
        path: 'cockpit-home', // 中央账号驾驶舱管理，两个模块共用入口
        name: 'cockpit-home',
        meta: { roleModule: ['sxzzjs', 'zzjs'], centralOnly: true },
        component: _import('workspace/cockpit-home/index')
      },
      {
        path: 'notice', // 消息列表
        name: 'notice',
        component: _import('workspace/notice/index')
      },
      {
        path: 'notice-add', // 发布通知
        name: 'notice-add',
        component: _import('workspace/notice/add')
      },
      {
        path: 'remind', // 预警列表
        name: 'remind',
        component: _import('workspace/remind/index')
      },
      {
        path: 'article', // 文章列表
        name: 'article',
        component: _import('workspace/article/index')
      },
      {
        path: 'article-add', // 发布文章
        name: 'article-add',
        component: _import('workspace/article/add')
      },
      {
        path: 'article-det', // 文章详情
        name: 'article-det',
        component: _import('workspace/article/detail')
      },
    ]
  },
  {
    path: '/updatePwd',
    name: 'updatePwd',
    component: _import('settings/updatePwd')
  },
  {
    path: '/building',
    name: 'building',
    component: _import('workspace/building')
  },
  {
    path: '/error/:code',
    name: 'errorPage',
    component: _import('workspace/errPage'),
    meta: { noAuth: true }
  },
  {
    path: '*',
    redirect: '/error/404'
  }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

const getCurrentRole = ({ roleModule, centralOnly }) => {
  const currentModule = ls.get('MODULE')
  const allowedModules = Array.isArray(roleModule) ? roleModule : [roleModule]
  if (!currentModule || !allowedModules.includes(currentModule)) return
  const currentRole = ls.get('userInfo') || {}
  const roles = ls.get('userPermission')
  const role = getRolesForModule(roles, currentModule)
    .find(item => getRoleKey(item) === getRoleKey(currentRole))
  if (!role || (centralOnly && !isCentralAccount(roles))) return
  return role
}

const withRoleQuery = location => {
  if (!ls.get('token')) return location
  const { route } = router.resolve(location)
  const role = getCurrentRole(route.meta)
  if (!role) return location
  const target = typeof location === 'string'
    ? { path: route.path, hash: route.hash }
    : location
  return {
    ...target,
    query: { ...route.query, roleId: String(role.id), type: role.type }
  }
}

// 提前补齐详情、侧栏和 router-link 的角色参数，避免正常跳转被守卫重定向并拒绝 Promise。
// 保留原生 Promise/回调及真实导航错误，不拦截或吞掉导航失败。
for (const method of ['push', 'replace']) {
  const navigate = router[method].bind(router)
  router[method] = (location, onComplete, onAbort) => {
    return navigate(withRoleQuery(location), onComplete, onAbort)
  }
}

router.beforeEach((to, from, next) => {
  const hasAuth = !!ls.get('token')
  if (to.meta.noAuth) {
    if (to.path === '/login' && hasAuth) {
      next({ path: '/' }) 
    } else {
      next()
    }
  } else {
    if (hasAuth) {
      const { roleModule } = to.meta
      if (roleModule) {
        const role = getCurrentRole(to.meta)
        if (!role) {
          next({ path: '/', replace: true })
          return
        }
        // 直接打开网址或刷新时补齐参数，不覆盖页面已有的 uid/mode 等参数。
        if (to.query.type !== role.type || to.query.roleId !== String(role.id)) {
          next({
            path: to.path,
            query: { ...to.query, roleId: String(role.id), type: role.type },
            hash: to.hash,
            replace: true
          })
          return
        }
      }
      next()
    } else {
      next({ path: `/login?redirect=${ encodeURIComponent(to.path) }`, replace: true })
    }
  }
})

export default router
